import $ from 'jquery';
import Cookies from 'js-cookie';

import validationRules from '../utils/validation';
import FormTools from '../utils/formTools';
import analytics from '../utils/analytics';

const surveyURL = 'https://action.lung.org/site/SSurvey';
const interestMapping = [
    { interestID: 4304, interest: 'advocate', urlMatch: '/become-an-advocate' },
    { interestID: 4306, interest: 'copd', urlMatch: '/lung-disease-lookup/copd' },
    { interestID: 4307, interest: 'asthma', urlMatch: '/lung-disease-lookup/athma' },
    { interestID: 4315, interest: 'research', urlMatch: '/lung-disease-lookup/asthma' },
    { interestID: 4315, interest: 'research', urlMatch: '/our-initiatives/research' },
    { interestID: 4308, interest: 'lungCancer', urlMatch: '/lung-disease-lookup/lung-cancer' },
    { interestID: 4309, interest: 'otherLungDiseases', urlMatch: '/lung-disease-lookup/', urlExclude: ['/lung-disease-lookup/copd', '/lung-disease-lookup/athma'] },
    { interestID: 4310, interest: 'healthyAir', urlMatch: '/our-initiatives/healthy-air' },
    { interestID: 4282, interest: 'healthyProfessionals', urlMatch: '/our-initiatives/education-and-training' },
    { interestID: 4311, interest: 'lungForceUpdates', urlMatch: '/our-initiatives/lung-force' },
    { interestID: 4312, interest: 'quitSmoking', urlMatch: '/stop-smoking' },
    { interestID: 4313, interest: 'tobaccoControl', urlMatch: '/our-initiatives/tobacco' },
    { interestID: 4314, interest: 'missionSupport', urlMatch: '/get-involved/events' },
    { interestID: 4317, interest: 'airClimbs', urlMatch: '/get-involved/events/fight-for-air-climb' },
    { interestID: 4318, interest: 'lungForceWalks', urlMatch: '/our-initiatives/lung-force' },
    { interestID: 4319, interest: 'galasLuncheons', urlMatch: '/get-involved/events/galas-and-other-events' },
    { interestID: 4320, interest: 'cyclingAdventures', urlMatch: '/get-involved/events/cycling-events' },
    { interestID: 4321, interest: 'otherEvents', urlMatch: '/get-involved/events/local' },
    { interestID: 4322, interest: 'volunteerOpp', urlMatch: '/get-involved/volunteer' },
];

const cookieID = 'ALA.Interests';

class Newsletter {
    constructor() {
    }

    init() {
        this.ft = new FormTools();
        this.checkCurrentUrl();
        this.updateFormListeners();
    }

    checkCurrentUrl() {
        // pull current cookie interests
        let cookieVal = Cookies.get(cookieID) || '';
        let userInterests = {};
        if (cookieVal === '') {
            userInterests = {};
        } else {
            try {
                let cookieParse = JSON.parse(cookieVal);
                userInterests = cookieParse;
            } catch {
                userInterests = {};
            }
        }

        // Check interests against current URL
        interestMapping.forEach(interest => {
            let intID = interest.interestID;
            let hasInterest = userInterests[intID] || false;
            if (!hasInterest && window.location.href.indexOf(interest.urlMatch) > -1) {
                // set cookie to match interest
                if (this.notExcluded(interest.urlExclude)) {
                    userInterests[intID] = true;
                    hasInterest = true;
                }
            }
            if (hasInterest) {
                $(`input[value='${intID}']`).prop('checked', true);
            }
        });

        //set Cookie to match latest interests
		Cookies.set(cookieID, userInterests, { sameSite: 'strict' });
    }

    updateFormListeners() {
        $('.js-newsletter-form form input[name=cons_email]').each((_, v) => {
            this.ft.emailSetup(v);
        });

        $('.js-newsletter-form form').submit((event) => {
            this.newsletterSignup(event.target, event);
        });
    }

    newsletterSignup(form, event) {
        // validate form data
        const email = $(form).find('input[name=cons_email]');
        let success = validationRules.emailValidate(email) || false;
        if (!success) {
            event.preventDefault();
        } else {
            const container = $(form).closest('.js-newsletter-form');
            this.toggleSubmitted(container);
            // push data layer
            analytics.newsletterSignup();
        }
    }

    toggleSubmitted(container) {
        const before = $(container).find('.newsletter-before');
        const after = $(container).find('.newsletter-after');
        $(before).addClass('d-none');
        $(after).removeClass('d-none');
    }

    notExcluded(urlExclude) {
        if (urlExclude == null || urlExclude.length === 0) {
            return true;
        }
        let noExclusion = true;
        urlExclude.forEach(u => {
            if (window.location.href.indexOf(u) > -1) {
                // excluded URL match, do not consider
                noExclusion = false;
            }
        });
        return noExclusion;
    }
}

export default Newsletter;